/* VialArt theme engine (2026-07-16): DARK by default, manual-only switching
   (auto time-of-day mode removed per owner). The toggle flips Light <-> Dark,
   persisted in localStorage va_theme; legacy 'auto' values read as dark.
   ?vatheme=light|dark forces a preview for the session (sessionStorage).
   The attribute html[data-vatheme] scopes assets/va-light.css. This file is loaded
   with a plain (non-defer) tag in <head> BEFORE the stylesheets so the first paint
   already has the right attribute - no flash. */
(function () {
  'use strict';
  var doc = document.documentElement;

  function stored() {
    try {
      var q = new URLSearchParams(location.search).get('vatheme');
      if (q && /^(light|dark)$/.test(q)) { sessionStorage.setItem('va_theme_prev', q); return q; }
      var sp = sessionStorage.getItem('va_theme_prev');
      if (sp === 'light' || sp === 'dark') return sp;
      var m = localStorage.getItem('va_theme');
      return (m === 'light' || m === 'dark') ? m : 'dark';   // default DARK; legacy 'auto' -> dark
    } catch (_) { return 'dark'; }
  }
  function eff(m) { return m; }

  function apply() {
    var m = stored(), e = eff(m);
    doc.setAttribute('data-vatheme', e);
    /* va-light.css loads conditionally now (theme.liquid) - inject it here for a
       live dark->light switch so the toggle keeps working without a reload. */
    if (e === 'light' && !document.getElementById('va-light-css') && window.VA_LIGHT_CSS) {
      var _l = document.createElement('link'); _l.id = 'va-light-css'; _l.rel = 'stylesheet'; _l.href = window.VA_LIGHT_CSS;
      (document.head || document.documentElement).appendChild(_l);
    }
    try { doc.style.colorScheme = e; } catch (_) {}
    var b = document.getElementById('va-thchip');
    if (b) {
      b.textContent = e === 'light' ? '☀️' : '🌙';
      b.title = 'Theme: ' + e + ' · tap to switch to ' + (e === 'light' ? 'dark' : 'light');
    }
  }
  apply();

  window.vaTheme = {
    mode: stored, apply: apply,
    cycle: function () {
      var n = stored() === 'light' ? 'dark' : 'light';
      try { localStorage.setItem('va_theme', n); sessionStorage.removeItem('va_theme_prev'); } catch (_) {}
      apply(); return n;
    }
  };

  // theme toggle lives IN the header actions row (next to account/cart) so it is
  // on every page; falls back to a floating chip only if the header slot is missing.
  // current-page marker: Horizon never sets aria-current on these menu links,
  // so mark the match ourselves - the pill/drawer CSS styles [aria-current].
  // (v4 regression: this definition was spliced out while its calls remained,
  //  which made chip() throw on entry - hence the instrumentation below.)
  function markCurrent() {
    var here = location.pathname.replace(/\/$/, '') || '/';
    document.querySelectorAll('.menu-list__link, .menu-drawer__menu-item, .va-mnav-item').forEach(function (a) {
      try {
        var p = new URL(a.href, location.origin).pathname.replace(/\/$/, '') || '/';
        if (p === here) a.setAttribute('aria-current', 'page');
      } catch (_) {}
    });
  }
  window.__vaChipLog = window.__vaChipLog || [];
  function LOG(x) { try { window.__vaChipLog.push(x + '@' + Math.round(performance.now())); } catch (_) {} }
  function chip() {
    LOG('chip:enter');
    try {
    markCurrent();
    setTimeout(markCurrent, 1200);   // drawer items are decorated late by the mnav script
    if (document.getElementById('va-thchip')) return;
    var b = document.createElement('button');
    b.id = 'va-thchip'; b.type = 'button';
    b.setAttribute('aria-label', 'Switch light/dark theme');
    b.addEventListener('click', function () { window.vaTheme.cycle(); });
    // NOTE: <header-actions> is a hydrating custom element that re-renders its
    // children (a button inserted inside gets wiped) - mount as its SIBLING.
    var slot = document.querySelector('header-actions');
    if (slot && slot.parentElement) {
      b.style.cssText = 'background:none;border:none;cursor:pointer;padding:6px;margin:0 2px 0 0;' +
        'font-size:17px;line-height:1;display:inline-flex;align-items:center;justify-content:center;align-self:center;';
      slot.parentElement.insertBefore(b, slot);
    } else {
      b.style.cssText = 'position:fixed;left:14px;bottom:calc(14px + env(safe-area-inset-bottom));z-index:999;' +
        'width:42px;height:42px;border-radius:999px;border:1px solid rgba(124,77,255,.4);cursor:pointer;' +
        'background:rgba(20,17,42,.72);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);' +
        'font-size:17px;line-height:1;display:flex;align-items:center;justify-content:center;padding:0;';
      document.body.appendChild(b);
      if (document.querySelector('.wz-bar, .va-mbar')) b.style.bottom = 'calc(84px + env(safe-area-inset-bottom))';
    }
    apply();
    LOG('chip:done slot=' + !!document.querySelector('header-actions') + ' mounted=' + !!document.getElementById('va-thchip'));
    } catch (e) { LOG('chip:THREW ' + (e && e.message)); }
  }
  function armChip() {
    LOG('armChip:called rs=' + document.readyState);
    chip();
    // Horizon morphs the header DOM after load and drops unknown nodes - re-mount
    // whenever the chip disappears (same observer pattern as the cart nudge).
    setTimeout(chip, 1000); setTimeout(chip, 3000);
    try {
      var hc = document.querySelector('header-component') || document.body;
      var t = null;
      new MutationObserver(function () {
        if (!document.getElementById('va-thchip')) { clearTimeout(t); t = setTimeout(chip, 200); }
      }).observe(hc, { childList: true, subtree: true });
    } catch (_) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armChip);
  else armChip();
})();
